<div class="view-product-details-container">
  <!-- Error Notification -->
  <div *ngIf="errorMessage" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ errorMessage }}</span>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <p>Loading product details...</p>
  </div>

  <!-- Product Details -->
  <div *ngIf="!loading && product" class="product-details-content">
    <!-- Header with Back Button, Title, and Print Button -->
    <div class="page-header">
      <div class="header-content-wrapper">
        <div class="header-left">
          <button class="btn-back" (click)="goBack()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="header-title-section">
            <h2>{{ product.name }}</h2>
            <div class="product-info-list">
              <div class="info-row">
                <span class="info-label">Product ID :</span>
                <span class="info-value">{{ product.productId || 'N/A' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Product Category :</span>
                <a *ngIf="!authService.isSupplier()" [routerLink]="['/product/category']" class="category-link">
                  {{ getCategoryDisplay(product.category) }}
                  <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
                <a *ngIf="authService.isSupplier()"  class="category-link">
                  {{ getCategoryDisplay(product.category) }}
                  <!-- <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg> -->
                </a>
              </div>
              <div class="info-row">
                <span class="info-label">Created On :</span>
                <span class="info-value">{{ formatDate(product.createdAt) }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Created By :</span>
                <span class="info-value">{{ product.createdBy?.name || 'Admin' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="header-right">
          <div class="product-image-section">
            <h3 class="product-image-heading">Product Image</h3>
            <div class="product-image-container">
              <div class="image-placeholder" *ngIf="!getProductImageUrl(product)">
                <div class="no-image-content">
                  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="60" height="60" fill="#e5e7eb" rx="4"/>
                    <path d="M30 18L37.5 27H22.5L30 18Z" fill="#9ca3af"/>
                    <rect x="15" y="30" width="30" height="18" fill="#9ca3af"/>
                  </svg>
                  <span class="no-image-text">No Image</span>
                </div>
              </div>
              <img *ngIf="getProductImageUrl(product)" 
                   [src]="getProductImageUrl(product)" 
                   [alt]="product.name"
                   class="product-main-image"
                   (error)="onProductImageError($event)">
              <div class="image-view-button-container" *ngIf="getProductImageUrl(product)">
                <button class="btn-view-image" (click)="viewProductImage()">
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn-print" (click)="printActiveTab()">
        <img src="assets/public/print.png" alt="Print" class="print-icon">
        <span>Print</span>
      </button>
    </div>

    <!-- Product Info (moved below header for better layout) -->
    <div class="product-info" style="display: none;">
      <!-- This section is hidden but kept for backward compatibility if needed -->
    </div>

    <!-- Tabs -->
    <div class="tabs-container">
      <div class="tabs">
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'details'"
          (click)="switchTab('details')">
          Details
        </button>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'requirements'"
          (click)="switchTab('requirements')">
          Requirements
        </button>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'share'"
          (click)="switchTab('share')"
          *ngIf="!authService.isSupplier()">
          Share
        </button>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'quote'"
          (click)="switchTab('quote')"
          *ngIf="!authService.isSupplier()">
          Quote
        </button>
      </div>
    </div>

    <!-- Details Tab -->
    <div class="tab-content" data-tab="details" *ngIf="activeTab === 'details'">
      <div class="specifications-section">
        <h4>Specifications</h4>
        <table class="specifications-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let spec of product.specifications; let i = index">
              <td class="sno-cell">{{ i + 1 }}</td>
              <td class="key-cell">{{ spec.key }}</td>
              <td class="value-cell">
                <div *ngIf="spec.keyType === 'Link'" class="link-container">
                  <a [href]="spec.value" target="_blank" class="link-value">{{ spec.value }}</a>
                </div>
                <div *ngIf="spec.keyType === 'Upload'" class="file-container">
                  <a [href]="spec.value" target="_blank" class="file-link">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="file-icon">
                      <path d="M14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H8L10 4H12C13.1046 4 14 4.89543 14 6Z" stroke="#1e40af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="file-name">{{ getFileName(spec.value) }}</span>
                  </a>
                  <div class="file-size">(File size - {{ getFileSize(spec.value) }})</div>
                </div>
                <div *ngIf="spec.keyType !== 'Link' && spec.keyType !== 'Upload'" class="text-container" [innerHTML]="formatSpecValue(spec.value)"></div>
              </td>
            </tr>
            <tr *ngIf="!product.specifications || product.specifications.length === 0">
              <td colspan="3" class="no-data">No specifications available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer Info -->
      <div class="footer-info">
        <div class="footer-item">Created on : <span class="shared-info-label">{{ formatDate(product.createdAt) }}</span> </div>
        <div class="footer-item">Created by : <span class="shared-info-label">{{ product.createdBy?.name || 'N/A' }}</span></div>
        <div class="footer-item" *ngIf="product.createdBy?.userType">Role : <span class="shared-info-label">{{ product.createdBy.userType }}</span></div>
      </div>
    </div>

    <!-- Requirements Tab -->
    <div class="tab-content" data-tab="requirements" *ngIf="activeTab === 'requirements'">
      <div class="requirements-section">
        <!-- <h3 class="requirements-heading">Requirements</h3> -->

        <!-- Quote Submission Due Date and Shipping Term - Inline -->
        <div class="requirement-info-row">
          <div class="requirement-info-item">
            <span class="requirement-label">Quote Submission Due Date:</span>
            <span class="requirement-value">{{ formatDate(product.quoteSubmissionDueDate) }}</span>
          </div>
          <div class="requirement-info-item">
            <span class="requirement-label">Shipping Term:</span>
            <span class="requirement-value">{{ product.shippingDetails?.shippingTerm || 'N/A' }}</span>
          </div>
        </div>

        <!-- Shipping Details Table -->
        <div *ngIf="product.shippingDetails?.shippingTerm === 'DELIVERED'" class="shipping-details-section">
          <h4 class="table-section-title">Shipping Details</h4>
          <table class="shipping-table">
            <thead>
              <tr>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
                <th>Country</th>
                <th>Pincode</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ getShippingAddress() }}</td>
                <td>{{ product.shippingDetails?.city || 'N/A' }}</td>
                <td>{{ product.shippingDetails?.state || 'N/A' }}</td>
                <td>{{ product.shippingDetails?.country || 'India' }}</td>
                <td>{{ product.shippingDetails?.pincode || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOB Shipping Details Table -->
        <div *ngIf="product.shippingDetails?.shippingTerm === 'FOB'" class="shipping-details-section">
          <h4 class="table-section-title">Shipping Details</h4>
          <table class="shipping-table">
            <thead>
              <tr>
                <th>Country</th>
                <th>Mapped Port</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ product.shippingDetails?.country || 'India' }}</td>
                <td>{{ product.shippingDetails?.mappedPort || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- CIF Shipping Details Table -->
        <div *ngIf="product.shippingDetails?.shippingTerm === 'CIF'" class="shipping-details-section">
          <h4 class="table-section-title">Shipping Details</h4>
          <table class="shipping-table">
            <thead>
              <tr>
                <th>Country</th>
                <th>Mapped Port</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ product.shippingDetails?.country || 'India' }}</td>
                <td>{{ product.shippingDetails?.mappedPort || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Quantity for Quote Table -->
        <div class="quantities-section">
          <h4 class="table-section-title">Quantity for Quote</h4>
          <table class="quantities-table">
            <thead>
              <tr>
                <th>Quantity</th>
                <th>UOM</th>
                <th>Is Mandatory ?</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let qty of product.quantities">
                <td>{{ formatNumber(qty.quantity) }}</td>
                <td>{{ qty.uom }}</td>
                <td>{{ qty.isMandatory ? 'Yes' : 'No' }}</td>
              </tr>
              <tr *ngIf="!product.quantities || product.quantities.length === 0">
                <td colspan="3" class="no-data">No quantities specified</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Share Tab -->
    <div class="tab-content" data-tab="share" *ngIf="activeTab === 'share'">
      <div class="share-section">
        <!-- Search and Filters -->
        <div class="filters-bar">
          <div class="search-box">
            <input 
              type="text" 
              class="search-input" 
              placeholder="Search by Supplier ID or Company Name" 
              [(ngModel)]="searchTerm" 
              (input)="onShareSearch()">
            <span class="search-icon">🔍</span>
          </div>
          <select class="filter-select" [(ngModel)]="selectedSupplierStatus" (change)="applyShareFilters()">
            <option value="">Filter by Supplier Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
          <select class="filter-select" [(ngModel)]="selectedQuoteStatus" (change)="applyShareFilters()">
            <option value="">Filter by Quote Status</option>
            <option value="Active">Active</option>
            <option value="Yet to Quote">Yet to Quote</option>
            <option value="Expired">Expired</option>
          </select>
          <button type="button" class="btn btn-reset" (click)="resetShareFilters()">Reset</button>
        </div>

        <!-- Summary Statistics -->
        <!-- <div class="summary-stats">
          <div class="stat-item">
            <span class="stat-label">Shared with : </span>
            <span class="stat-value">{{ getFilteredSharedCount() }}</span>
            <span class="stat-space"> | </span> 
          </div>
          <div class="stat-item">
            <span class="stat-label">Quote : </span>
            <span class="stat-value">{{ getFilteredQuotedCount() }}</span> 
            <span class="stat-space"> | </span>
          </div>
          <div class="stat-item">
            <span class="stat-label">Yet to Quote : </span>
            <span class="stat-value">{{ getFilteredYetToQuoteCount() }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">Unshared with : </span>
            <span class="stat-value">{{ getFilteredUnsharedCount() }}</span>
          </div>
        </div> -->

        <!-- Suppliers Table -->
        <div class="suppliers-table-container" #suppliersTableContainer (click)="closeActionMenus()">
          <table class="suppliers-table">
            <thead>
              <tr>
                <th>Supplier ID</th>
                <th>Supplier Company</th>
                <th>Shared (DD/MM/YYYY)</th>
                <th>Quote (DD/MM/YYYY)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of displayedSuppliers">
                <td>
                  <div class="supplier-id-cell">
                    <a [routerLink]="['/supplier/view', item.supplier._id]" class="supplier-link">
                      {{ item.supplier.supplierId || item.supplier._id }}
                      <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </a>
                    <span class="status-badge" [ngClass]="item.supplier.isActive ? 'status-active' : 'status-inactive'">
                      {{ item.supplier.isActive ? 'Active' : 'Deactive' }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="supplier-company-cell">
                    <a [routerLink]="['/supplier/view', item.supplier._id]" class="company-link">
                      {{ item.supplier.companyName || item.supplier.name }}
                      <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </a>
                    <div class="company-location">{{ item.supplier.city || '' }}{{ item.supplier.city && item.supplier.country ? ',' : '' }} {{ item.supplier.country || '' }}</div>
                  </div>
                </td>
                <td>
                  <div class="shared-info">
                    <div *ngIf="!item.quote?.isUnshared">
                      <div><span class="shared-info-label">On : </span>{{ formatDate(item.sharedOn) }}</div>
                      <div><span class="shared-info-label">By : </span>{{ item.sharedBy?.name || 'N/A' }}</div>
                    </div>
                    <div *ngIf="item.quote?.isUnshared" class="unshared-info">
                      <div class="unshared-badge">Unshared</div>
                      <div><span class="shared-info-label">On : </span>{{ formatDate(item.quote.unsharedAt) }}</div>
                      <div><span class="shared-info-label">By : </span>{{ item.quote.unsharedBy?.name || 'N/A' }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="quote-info" *ngIf="item.quote && !item.quote.isUnshared">
                    <div><span class="shared-info-label">Status : </span><span class="quote-status" [ngClass]="getQuoteStatusClass(item.quote.status)">{{ getQuoteStatusText(item.quote) }}</span></div>
                    <div><span class="shared-info-label">On : </span>{{ formatDate(item.quote.submittedOn || item.quote.submittedAt) }}</div>
                    <div><span class="shared-info-label">Valid Upto : </span>{{ formatDate(item.quote.validUpto || item.quote.validityDate) }}</div>
                  </div>
                  <div class="quote-info" *ngIf="item.quote && item.quote.isUnshared">
                    <div><span class="shared-info-label">Status : </span>NA</div>
                    <div><span class="shared-info-label">On : </span>NA</div>
                    <div><span class="shared-info-label">Valid Upto : </span>NA</div>
                  </div>
                  <div class="quote-info" *ngIf="!item.quote">
                    <div><span class="shared-info-label">Status : </span><span class="quote-status status-pending">Yet to Quote</span></div>
                    <div><span class="shared-info-label">On : </span>NA</div>
                    <div><span class="shared-info-label">Valid Upto : </span>NA</div>
                  </div>
                </td>
                <td>
                  <div class="action-menu-container" *ngIf="item.quote">
                    <button 
                      type="button" 
                      class="action-menu-btn"
                      (click)="$event.stopPropagation(); toggleActionMenu(item.supplier._id)"
                      [class.active]="showActionMenu[item.supplier._id]">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="4" r="1.5" fill="currentColor"/>
                        <circle cx="10" cy="10" r="1.5" fill="currentColor"/>
                        <circle cx="10" cy="16" r="1.5" fill="currentColor"/>
                      </svg>
                    </button>
                    <div 
                      class="action-menu-dropdown" 
                      *ngIf="showActionMenu[item.supplier._id]"
                      (click)="$event.stopPropagation()">
                      <button 
                        type="button" 
                        class="action-menu-item"
                        *ngIf="!item.quote.isUnshared"
                        (click)="unshareQuote(item.quote._id, item.supplier._id)">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 2V14M2 8H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Unshare
                      </button>
                      <button 
                        type="button" 
                        class="action-menu-item"
                        *ngIf="item.quote.isUnshared"
                        (click)="reshareQuote(item.quote._id, item.supplier._id)">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 2V14M2 8H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Reshare
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayedSuppliers.length === 0 && !loading">
                <td colspan="5" class="no-data">No suppliers found</td>
              </tr>
            </tbody>
          </table>
          
          <!-- Infinite Scroll Loading Indicator -->
          <div class="infinite-scroll-loader" *ngIf="isLoadingMore">
            <div class="loader-spinner"></div>
            <span>Loading more suppliers...</span>
          </div>
          
          <!-- End of Data Message -->
          <div class="end-of-data" *ngIf="!hasMoreData && !loading && displayedSuppliers.length > 0">
            <p>No more suppliers to load</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Quote Tab -->
    <div class="tab-content" data-tab="quote" *ngIf="activeTab === 'quote'">
      <div class="quote-section-wrapper">
        <div class="quote-section">
        <!-- Search and Filter Bar -->
        <div class="search-filter-bar">
          <div class="search-input-wrapper">
            <input
              type="text"
              class="search-input"
              placeholder="Search by Quote ID or Supplier Name or Supplier ID"
              [(ngModel)]="quoteSearchTerm"
              (input)="onQuoteSearchChange()">
            <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="9" r="6" stroke="#6b7280" stroke-width="1.5"/>
              <path d="M14 14L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>
          
          <select class="filter-select" [(ngModel)]="quoteStatusFilter" (change)="onQuoteStatusFilterChange()">
            <option value="">Filter by Quote Status</option>
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
          </select>
          
          <button class="btn-reset" (click)="resetQuoteFilters()">Reset</button>
          
          <button class="btn-compare" (click)="compareQuotes()" [disabled]="selectedQuotes.size < 2">
            Compare Quotes
          </button>
        </div>

        <!-- Loading State -->
        <div *ngIf="quotesLoading" class="loading-state">
          <p>Loading quotes...</p>
        </div>

        <!-- Quotes Table -->
        <div *ngIf="!quotesLoading" class="table-container">
          <table class="quotes-table">
            <thead>
              <tr>
                <th style="width: 50px; min-width: 50px; max-width: 50px; text-align: center;">
                  <input
                    type="checkbox"
                    [checked]="selectedQuotes.size === filteredQuotes.length && filteredQuotes.length > 0"
                    (change)="toggleAllQuotes()">
                </th>
                <th>Quote ID</th>
                <th>Supplier</th>
                <th>Quoted on
                  <span class="quote-label">(DD/MM/YYYY)</span>
                </th>
                <th>Price</th>
                <th>Shipping Term</th>
                <th>Valid Upto
                  <span class="quote-label">(DD/MM/YYYY)</span>
                  </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let quote of filteredQuotes">
                <td style="width: 50px; min-width: 50px; max-width: 50px; text-align: center;">
                  <input
                    type="checkbox"
                    [checked]="selectedQuotes.has(quote._id)"
                    (change)="toggleQuoteSelection(quote._id)"
                    (click)="$event.stopPropagation()">
                </td>
                <td class="quote-id-cell">
                  <div class="quote-id-text" (click)="viewQuoteDetails(quote)" style="cursor: pointer; display: flex; align-items: center; gap: 8px;">
                    {{ quote.quoteId || '-' }}
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 2H4C3.44772 2 3 2.44772 3 3V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V6M10 2L13 5M10 2V5H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span class="status-badge-small" [ngClass]="getSupplierValidDateStatusClass(quote.supplierValidDateStatus)">
                    {{ getSupplierValidDateStatusText(quote.supplierValidDateStatus) }}
                  </span>
                </td>
                <td class="supplier-cell">
                  <div class="supplier-name">{{ quote.supplier?.companyName || quote.supplier?.name || '-' }}</div>
                  <div class="supplier-id" *ngIf="quote.supplier?.supplierId">(ID: {{ quote.supplier.supplierId }})</div>
                </td>
                <td style="width: 140px; min-width: 140px; max-width: 140px; white-space: nowrap;">{{ formatDate(quote.submittedAt || quote.submittedOn) }}</td>
                <td class="price-cell">
                  <ng-container *ngIf="getQuotePriceRange(quote).min > 0 && getQuotePriceRange(quote).max > 0">
                    Min: {{ formatNumber(getQuotePriceRange(quote).min) }} INR, Max: {{ formatNumber(getQuotePriceRange(quote).max) }} INR
                  </ng-container>
                  <ng-container *ngIf="getQuotePriceRange(quote).min === 0 && getQuotePriceRange(quote).max === 0">
                    -
                  </ng-container>
                </td>
                <td class="shipping-term-cell">{{ getShippingTermDisplay(quote) }}</td>
                <td style="width: 140px; min-width: 140px; max-width: 140px; white-space: nowrap;">{{ formatDate(quote.validityDate || quote.validUpto) }}</td>
              </tr>
              <tr *ngIf="filteredQuotes.length === 0">
                <td colspan="7" class="no-data">No quotes found</td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Unshare Confirmation Modal -->
  <app-confirmation-modal
    [isOpen]="showUnshareModal"
    [message]="unshareModalMessage"
    [confirmText]="'Confirm'"
    [cancelText]="'Cancel'"
    (confirm)="onConfirmUnshare()"
    (cancel)="closeUnshareModal()"
    (close)="closeUnshareModal()">
  </app-confirmation-modal>

  <!-- Image View Modal -->
  <div class="image-modal-overlay" *ngIf="showImageModal" (click)="closeImageModal()">
    <div class="image-modal-content" (click)="$event.stopPropagation()">
      <div class="image-modal-header">
        <span class="image-modal-title">{{ modalImageName }}</span>
        <button class="image-modal-close" (click)="closeImageModal()" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="image-modal-body">
        <img [src]="modalImageUrl" [alt]="modalImageName" class="modal-image">
      </div>
      <div class="image-modal-footer">
        <button class="btn-download" (click)="downloadImage()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2.5V12.5M10 12.5L6.25 8.75M10 12.5L13.75 8.75M3.75 12.5V15.8333C3.75 16.75 4.5 17.5 5.41667 17.5H14.5833C15.5 17.5 16.25 16.75 16.25 15.8333V12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Download</span>
        </button>
      </div>
    </div>
  </div>

</div>

